<app-option-bar [type]="'GOPHER'"></app-option-bar>
<div class="gopher-wrapper">
  <div class="container-fluid">
    <div class="content-wrapper">
      <div class="inner-nav">
        <app-left-menu [type]="'GOPHER'"></app-left-menu>
      </div>

      <div class="inner-content collapsed">
        <div class="common-section">
          <div class="common-heading">Create attack</div>
          <div class="common-box">
            <div class="row mt-3">
              <div class="col-md-2 font-bold">Project</div>
              <div class="col-md-4">
                <ng-select
                  class="custom-style"
                  chosen
                  [items]="myProjects"
                  bindLabel="name"
                  [clearable]="false"
                  [(ngModel)]="config.project"
                  (change)="getClientsById(config.project)"
                  placeholder="Select Project"
                  [searchable]="true"
                >
                  <ng-template ng-option-tmp let-item="item">
                    <div title="{{ item.name }}" class="text-truncate">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-md-2 mt-3">
                <a *ngIf="config.project" [routerLink]="['../../client']" [queryParams]="{ project: config.project.id }">
                  <span class="fa fa-plus"></span> Add clients
                </a>
              </div>
            </div>

            <div class="row relay-margin-top-10" [ngbCollapse]="!showAdd">
              <div class="col-md-3">Add infrastructure details</div>
              <div class="col-md-9">
                <div class="row">
                  <div class="col-md-3">
                    <label>Server type</label>
                    <ng-select class="custom-style" id="config-server" [(ngModel)]="config.server_type" [clearable]="false" [searchable]="false">
                      <ng-option value="Web server">Web server</ng-option>
                      <ng-option value="Application server">Application server</ng-option>
                      <ng-option value="Database server">Database server</ng-option>
                      <ng-option value="Other components">Other components</ng-option>
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label>Name</label>
                    <input type="text" id="config-name-server" [(ngModel)]="config.name" class="form-control" />
                  </div>
                  <div class="col-md-4">
                    <label>Host name</label>
                    <input type="text" id="config-hostAddress" [(ngModel)]="config.hostAddress" class="form-control" />
                  </div>
                  <div class="col-md-4">
                    <label>Username</label>
                    <input type="text" id="config-username" [(ngModel)]="config.userName" class="form-control" />
                  </div>
                </div>
              </div>
            </div>

            <hr />
            <!-- Host file -->
            <div *ngIf="config.project">
              <div class="table-responsive">
                <ul class="list-inline tab-link">
                  <li><a class="link">Host</a></li>
                </ul>
                <table class="table table-condensed table-bordered">
                  <thead>
                    <tr class="active">
                      <th>Name</th>
                      <th>Username</th>
                      <th>Server type</th>
                      <th>Hostname</th>
                      <th>Status</th>
                      <th class="text-center">Select</th>
                    </tr>
                  </thead>
                  <tr *ngIf="attackClients && attackClients.length === 0">
                    <td colspan="6">No clients found please add one.</td>
                  </tr>
                  <tr *ngFor="let val of attackClients">
                    <td>{{ val.name }}</td>
                    <td>{{ val.userName }}</td>
                    <td>{{ val.server_type }}</td>
                    <td>{{ val.hostAddress }}</td>
                    <td>{{ val.status }}</td>
                    <td class="text-center">
                      <input type="radio" [value]="val.id" [(ngModel)]="attack.gopherClient.id" *ngIf="val.status === 'AVAILABLE'" />
                    </td>
                  </tr>
                </table>
              </div>

              <div class="new-attack-sec">
                <div class="sub-title">Attack type</div>
                <div class="create-gopher-sec">
                  <div class="row sec">
                    <!-- Resource -->
                    <div class="col command-sec">
                      <div class="title">
                        Resource <br />
                        <small>Impact cores, workers and memory</small>
                      </div>
                      <hr />
                      <div class="opt-sec">
                        <div class="radio">
                          <label>
                            <input type="radio" name="commandType" [(ngModel)]="attack.type" value="CPU" /> CPU<br />
                            <small>Consumes CPU resource</small>
                          </label>
                        </div>
                        <div class="radio">
                          <label>
                            <input type="radio" name="commandType" [(ngModel)]="attack.type" value="DISK" /> Disk<br />
                            <small>Consumes disk space</small>
                          </label>
                        </div>
                        <div class="radio disabled">
                          <label>
                            <input type="radio" name="commandType" [disabled]="true" [(ngModel)]="attack.type" value="IO" /> IO<br />
                            <small>Consumes targeted file system device resources</small>
                          </label>
                        </div>
                        <div class="radio">
                          <label>
                            <input type="radio" name="commandType" [(ngModel)]="attack.type" value="MEMORY" /> Memory<br />
                            <small>Consumes memory</small>
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- CPU attack section  -->
                    <div class="opt-desc" *ngIf="attack.type == 'CPU'">
                      <!--  ng-init='attack.args = {}' -->
                      <div class="row">
                        <div class="col-md-8">
                          Length <span class="error-msg">*</span>
                          <small>The length of attack (seconds)</small>
                        </div>
                        <div class="col-md-4">
                          <input type="number" min="1" value="0" id="attack-len" class="form-control" [(ngModel)]="attack.args.duration" required />
                        </div>
                        <div class="col-md-8 relay-margin-top-10">
                          Cores <span class="error-msg">*</span>
                          <small>The number of CPU cores to hog</small>
                        </div>
                        <div class="col-md-4 relay-margin-top-10">
                          <input type="number" min="1" name="" id="attack-core" class="form-control" [(ngModel)]="attack.args.core" required />
                        </div>
                      </div>
                    </div>

                    <!-- DISK attack section  -->
                    <div class="opt-desc" *ngIf="attack.type == 'DISK'">
                      <!--ng-init='attack.args = {}'-->
                      <div class="row">
                        <div class="col-md-8">
                          Percentage <span class="error-msg">*</span>
                          <small></small>
                        </div>
                        <div class="col-md-4">
                          <input
                            type="number"
                            min="1"
                            value="0"
                            id="attack-perc"
                            class="form-control"
                            [(ngModel)]="attack.args.percentage"
                            required
                          />
                        </div>
                        <div class="col-md-8 relay-margin-top-10">
                          Duration <span class="error-msg">*</span>
                          <small></small>
                        </div>
                        <div class="col-md-4 relay-margin-top-10">
                          <input
                            type="number"
                            min="1"
                            name=""
                            id="attack-duration"
                            class="form-control"
                            [(ngModel)]="attack.args.duration"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <!-- MEMORY attack section  -->
                    <div class="opt-desc" *ngIf="attack.type == 'MEMORY'">
                      <!-- ng-init='attack.args = {}' -->
                      <div class="row">
                        <div class="col-md-8">
                          Percentage <span class="error-msg">*</span>
                          <small></small>
                        </div>
                        <div class="col-md-4">
                          <input
                            type="number"
                            min="1"
                            value="0"
                            id="attack-perc"
                            class="form-control"
                            [(ngModel)]="attack.args.percentage"
                            required
                          />
                        </div>
                        <div class="col-md-8 relay-margin-top-10">
                          Duration <span class="error-msg">*</span>
                          <small></small>
                        </div>
                        <div class="col-md-4 relay-margin-top-10">
                          <input
                            type="number"
                            min="1"
                            name=""
                            id="attack-duration"
                            class="form-control"
                            [(ngModel)]="attack.args.duration"
                            required
                          />
                        </div>
                        <div class="col-md-8 relay-margin-top-10">Use swap</div>
                        <div class="col-md-4 relay-margin-top-10">
                          <!-- <relay-toogle-button class="mandatory-sec" id="use-swap"
													[(ngModel)]="attack.args.useSwap" on-value="true"
													off-value="false" on="Yes" off="No" on-style="#00a8a9"
													off-style="rgb(126, 132, 127)"></relay-toogle-button> -->
                          <ui-switch size="small" [(ngModel)]="attack.args.useSwap" checkedLabel="Yes" uncheckedLabel="No" class="mandatory-sec">
                          </ui-switch>
                        </div>
                      </div>
                    </div>

                    <!-- State -->
                    <div class="col command-sec">
                      <div class="title">
                        State <br />
                        <small>Impact cores, workers and memory</small>
                      </div>
                      <hr />
                      <div class="opt-sec">
                        <div class="radio disabled">
                          <label>
                            <input type="radio" name="commandType" disabled />Process killer<br />
                            <small>An attack which kills the specified process</small>
                          </label>
                        </div>
                        <div class="radio">
                          <label>
                            <input type="radio" name="commandType" [(ngModel)]="attack.type" value="SHUTDOWN" /> Shutdown<br />
                            <small>Reboots or shutdowns the targeted host operating system</small>
                          </label>
                        </div>
                        <div class="radio disabled">
                          <label>
                            <input type="radio" name="commandType" [disabled]="true" />Time travel<br />
                            <small>Changes the system time</small>
                          </label>
                        </div>
                      </div>
                      <!--  -->
                      <div class="opt-desc" *ngIf="attack.type == 'SHUTDOWN'" ng-init="attack.args = {}">
                        <div class="row">
                          <div class="col-md-8">Delay</div>
                          <div class="col-md-4">
                            <input type="number" min="0" name="" id="" class="form-control" [(ngModel)]="attack.args.delay" />
                          </div>
                          <div class="col-md-8 relay-margin-top-10">Reboot</div>
                          <div class="col-md-4 relay-margin-top-10">
                            <!-- <relay-toogle-button class="mandatory-sec" id="env-specific"
															[(ngModel)]="attack.reboot" on-value="true" off-value="false"
															on="Yes" off="No" on-style="#00a8a9"
															off-style="rgb(126, 132, 127)"></relay-toogle-button> -->
                            <ui-switch size="small" [(ngModel)]="attack.reboot" checkedLabel="Yes" uncheckedLabel="No" class="mandatory-sec">
                            </ui-switch>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Network -->
                    <div class="col command-sec">
                      <div class="title">
                        Network <br />
                        <small>Impact cores, workers and memory</small>
                      </div>
                      <hr />
                      <div class="opt-sec">
                        <div class="radio disabled">
                          <label>
                            <input type="radio" name="commandType" [disabled]="true" /> Blackhole
                            <br />
                            <small>Impact cores, workers and memory</small>
                          </label>
                        </div>
                        <div class="radio disabled">
                          <label>
                            <input type="radio" name="commandType" [disabled]="true" /> DNS <br />
                            <small>Impact cores, workers and memory</small>
                          </label>
                        </div>
                        <div class="radio disabled">
                          <label>
                            <input type="radio" name="commandType" [disabled]="true" /> Latency <br />
                            <small>Impact cores, workers and memory</small>
                          </label>
                        </div>
                        <div class="radio disabled">
                          <label>
                            <input type="radio" name="commandType" [disabled]="true" /> Packet loss
                            <br />
                            <small>Impact cores, workers and memory</small>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Clients section -->
              <hr />
              <div class="text-center" *ngIf="attack.gopherClient.id">
                <button class="btn btn-primary btn-sm" (click)="saveAttack(attack)">Run the attack</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
